import installer from "./defaults";
export * from "./setupFormily";
export * from "./make-installer";
export * from "./formily";
export * from "@vue-admin-core/components";
export * from "@vue-admin-core/hooks";
export * from "@vue-admin-core/utils";
export * from "./createSchemaField";

export const install = installer.install;
export const version = installer.version;
export default installer;
